<div class="page-header">
    <div class="title-section">
        <h2 class="page-title">Menu FAT</h2>
        <p class="page-subtitle">Liste de l'ensemble des FAT de tous les projets</p>
    </div>
</div>

<div class="card shadow-sm">
    <div class="search-bar">
        <div class="search-bar-content">
            <div class="search-input-wrapper">
                <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
                <input type="text" [(ngModel)]="searchQuery" (input)="onSearchChange($event)"
                    placeholder="Rechercher par N° FAT ou projet..." class="search-input" />
            </div>
        </div>
    </div>
    <div class="table-responsive">
        <table class="modern-table" matSort (matSortChange)="onSortChange($event)" [matSortActive]="sortField"
            [matSortDirection]="sortDirection">
            <thead>
                <tr>
                    <th mat-sort-header="fatNumber">N° FAT</th>
                    <th mat-sort-header="projectName">Nom du projet</th>
                    <th mat-sort-header="createdAt">Créée le</th>
                    <th mat-sort-header="status">Statut</th>
                </tr>
            </thead>
            <tbody>
                @for (fat of fats(); track fat.id) {
                <tr (click)="onView(fat)" class="clickable-row">
                    <td>{{ fat.fatNumber }}</td>
                    <td>{{ fat.projectName }}</td>
                    <td>{{ fat.createdAt | date:'dd/MM/yyyy à HH:mm' }}</td>
                    <td>
                        <span class="status-badge" [attr.data-meta]="fat.statusMeta"
                            [style.background-color]="fat.statusColor">
                            {{ fat.status }}
                        </span>
                    </td>
                </tr>
                } @empty {
                <tr class="empty-row">
                    <td colspan="4">
                        <div class="empty-state">
                            <mat-icon class="empty-icon" aria-hidden="true">assignment</mat-icon>
                            <p>Aucune FAT trouvée</p>
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>

    <mat-paginator [length]="totalElements()" [pageSize]="size()" [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="onPageChange($event)" aria-label="Sélectionner la page">
    </mat-paginator>
</div>
